/* eslint-disable @typescript-eslint/naming-convention */
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  FormControlLabel,
  Grid,
  InputAdornment,
  TextField,
  Tooltip,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
} from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import moment from 'moment';
import * as React from 'react';
import { DateRange } from 'react-date-range';
import { casesApi } from 'src/api/casesApi';
import { Drawer } from '@mui/material';
import { width } from '@material-ui/system';

const useStyles = makeStyles(() =>
  createStyles({
    createFormSideBar: {
      width: '30%',
      border: 'none',
      '& .ticketBody': {
        height: '90vh',
        overflowY: 'auto',
        padding: '5px 20px',
        '& input': {
          borderRadius: '2px',
        },
      },
      '& .calenderFilter': {
        '& .MuiBox-root': {
          right: '20px !important',
        },
      },
      '& h4': {
        background: '#C22027',
        color: '#fff',
        padding: '10px 40px',
        margin: '-5px -20px 30px',
        height: '64px',
        display: 'flex',
        alignItems: 'center',
      },
      '& label': {
        letterSpacing: ' 0.15px',
        color: '#231F20',
        fontWeight: '600',
        display: 'block',
      },

      '& select': {
        minHeight: '22px !important',
        padding: '0 10px',
        lineHeight: '116.7%',
        color: '#696969',
        width: '100%',
        '& .MuiAutocomplete-input': {
          minHeight: '38px !important',
          padding: 0,
        },
      },
      '& .MuiSelect-root': {
        minHeight: '38px',
      },
      '& .customField': {
        minHeight: '38px !important',
        padding: '0 10px',
        lineHeight: '116.7%',
        color: '#696969',
        width: '100%',
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        '& .MuiChip-root': {
          border: 0,
          borderRadius: '4px',
          margin: '2px 0',
          background: 'rgb(241 240 240)',
        },
      },
      '& .labelsDataCss .MuiAutocomplete-inputRoot': {
        height: 'initial',
      },
      '& .ticketDropDown+.ticketDropDown': {
        marginTop: '15px',
      },
      '& .submitTicket ': {
        margin: '35px 0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      },
      '& .submitTicket button+button': {
        marginLeft: '15px',
      },
      '& .btns': {
        display: 'flex',
        marginTop: '20px',
        '& button': {
          width: '115px',
          height: 30,
        },
      },
      '& .select_item': {
        '& .MuiOutlinedInput-root': {
          width: '100%',
          maxHeight: '46px',
        },
      },
    },
    advancedFilter: {
      '& .fields+.fields': {
        marginTop: '15px',
      },
      '& .datefield': {
        position: 'relative',
        '& .rdrCalendarWrapper': {
          zIndex: '999',
          position: 'absolute',
          right: '-1px',
          borderRadius: '5px',
          border: '1px solid rgb(239, 242, 247)',
          '& .rdrDateDisplayWrapper': {
            borderTopLeftRadius: '5px',
            borderTopRightRadius: '5px',
          },
        },
      },
    },
    datePicker: {
      zIndex: '999',
      position: 'absolute',
      borderRadius: '5px',
    },
  })
);
const isApprovedOptions = [
  { value: 'null', label: 'Select Value' },
  { value: 'true', label: 'Approved' },
  { value: 'false', label: 'Not Approved' },
];
export default function CaseFilter(props: any) {
  const {
    _isOpen,
    _setShowAdvancedSearch,
    _search,
    _setSearch,
    _caseType,
    _setCaseType,
    _priority,
    _setPriority,
    _stakeholder,
    _setStakeholder,
    _assignee,
    _setAssignee,
    _projectSponser,
    _setProjectSponser,
    _escalationManager,
    _setEscalationManager,
    _status,
    _setStatus,
    _excludeStatus,
    _setExcludeStatus,
    _hasAttachments,
    _setHasAttachments,
    _isEscalated,
    _setIsEscalated,
    _isFirstResponseTimeViolated,
    _setIsFirstResponseTimeViolated,
    _isSynced,
    _setIsSynced,
    _isResolveTimeViolated,
    _setIsResolveTimeViolated,
    _date,
    _setDate,
    _project,
    _setProject,
    _organization,
    _setOrganization,
    _setFiltersApplied,
    _filtersApplied,
    isSubmit,
    setIsSubmit,
    _module,
    _setModule,
    _isApproved,
    _setIsApproved,
  } = props;
  const handleClose = () => {
    _setShowAdvancedSearch(false);
  };
  const classes: any = useStyles();

  const [search, setSearch] = React.useState(_search);

  const handleSearch = (e) => {
    setSearch(e.target.value);
    _setSearch(e.target.value);
    if (!isSubmit) return;

    if (e.target.value === '') {
      _setFiltersApplied({
        ..._filtersApplied,
        search: null,
      });
    } else {
      _setFiltersApplied({
        ..._filtersApplied,
        search: {
          name: 'Search',
          data: e.target.value,
        },
      });
    }
  };

  const [approvedList, setApprovedList] = React.useState(isApprovedOptions);

  /** date */
  const [state, setState] = React.useState<any>([
    {
      startDate: null,
      endDate: null,
      key: 'selection',
      color: '#c22027',
    },
  ]);
  const [isOpen, setIsOpen] = React.useState(false);
  const ref = React.useRef(null);
  const [allOrganizations, setAllOrganizations] = React.useState([]);
  const getAllOrganizations = async () => {
    try {
      const res = await casesApi.getAllOrganizations();
      setAllOrganizations(res?.data || []);
    } catch (error) {
      setAllOrganizations([]);
    }
  };

  const [allStatuses, setAllStatuses] = React.useState([]);
  const getAllStatuses = async () => {
    try {
      const res = await casesApi?.getStatuses();
      setAllStatuses(res?.data || []);
    } catch (error) {
      setAllStatuses([]);
    }
  };

  const [allPriorities, setAllPriorities] = React.useState([]);
  const getAllPriorities = async () => {
    try {
      const response = await casesApi.getPriorities();
      setAllPriorities(response?.data || []);
    } catch (error) {
      setAllPriorities([]);
    }
  };

  const [allProjects, setAllProjects] = React.useState([]);
  const getAllProjects = async () => {
    try {
      const response = await casesApi.getAllProjects();
      setAllProjects(response?.data || []);
    } catch (error) {
      setAllProjects([]);
    }
  };

  const [allCaseTypes, setAllCaseTypes] = React.useState([]);
  const getAllCaseTypes = async () => {
    try {
      const response = await casesApi.getCaseTypes();
      setAllCaseTypes(response?.data || []);
    } catch (error) {
      setAllCaseTypes([]);
    }
  };

  const toggleHasAttachments = () => {
    _setHasAttachments(!_hasAttachments);
    if (!isSubmit) return;
    if (_hasAttachments) {
      _setFiltersApplied({
        ..._filtersApplied,
        hasAttachments: null,
      });
    } else {
      _setFiltersApplied({
        ..._filtersApplied,
        hasAttachments: {
          name: 'Attachments',
          data: 'True',
        },
      });
    }
  };
  /** is-escalated */

  const toggleIsEscalated = () => {
    _setIsEscalated(!_isEscalated);
    if (!isSubmit) return;
    if (_isEscalated) {
      _setFiltersApplied({
        ..._filtersApplied,
        escalatedCases: null,
      });
    } else {
      _setFiltersApplied({
        ..._filtersApplied,
        escalatedCases: {
          name: 'Escalated',
          data: 'True',
        },
      });
    }
  };
  const toggleIsFirstResponseTimeViolated = () => {
    _setIsFirstResponseTimeViolated(!_isFirstResponseTimeViolated);
    if (!isSubmit) return;
    if (_isFirstResponseTimeViolated) {
      _setFiltersApplied({
        ..._filtersApplied,
        isFirstResponseTimeViolated: null,
      });
    } else {
      _setFiltersApplied({
        ..._filtersApplied,
        isFirstResponseTimeViolated: {
          name: 'First Time Violated',
          data: 'True',
        },
      });
    }
  };
  /** is-sync */

  const toggleIsSynced = () => {
    _setIsSynced(!_isSynced);
    if (!isSubmit) return;
    if (_isSynced) {
      _setFiltersApplied({
        ..._filtersApplied,
        thirdPartySync: null,
      });
    } else {
      _setFiltersApplied({
        ..._filtersApplied,
        thirdPartySync: {
          name: 'Third Party Sync',
          data: 'True',
        },
      });
    }
  };

  const toggleIsResolveTimeViolated = () => {
    _setIsResolveTimeViolated(!_isResolveTimeViolated);
    if (!isSubmit) return;
    if (_isResolveTimeViolated) {
      _setFiltersApplied({
        ..._filtersApplied,
        isResolveTimeViolated: null,
      });
    } else {
      _setFiltersApplied({
        ..._filtersApplied,
        isResolveTimeViolated: {
          name: 'Resolve Time Violated',
          data: 'True',
        },
      });
    }
  };

  /** internal-users */
  const [allInternalUsers, setAllInternalUsers] = React.useState([]);
  const getAllInternalUsers = async () => {
    try {
      const response = await casesApi.getUserById(false);
      if (response?.status === 200) {
        setAllInternalUsers(response?.data || []);
      }
    } catch (error) {
      setAllInternalUsers([]);
    }
  };

  /** internal-users */
  const [allExternalUsers, setAllExternalUsers] = React.useState([]);
  const getAllExteranlUsers = async () => {
    try {
      const res = await casesApi?.getAutoCompleteUser(true);
      setAllExternalUsers(res?.data || []);
    } catch (error) {
      setAllExternalUsers([]);
    }
  };
  const [allModules, setAllModules] = React.useState([]);
  const ageOptions = [
    { value: 10, label: 'Ten' },
    { value: 20, label: 'Twenty' },
    { value: 30, label: 'Thirty' },
  ];
  const getAllModules = async () => {
    try {
      const response = await casesApi.getAutoCompleteModule();
      setAllModules(response?.data || []);
    } catch (error) {
      setAllModules([]);
    }
  };

  React.useEffect(() => {
    getAllCaseTypes();
    getAllPriorities();
    getAllInternalUsers();
    getAllExteranlUsers();
    getAllStatuses();
    getAllProjects();
    getAllOrganizations();
    getAllModules();
  }, []);

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleReset = () => {
    setIsSubmit(true);
    _setSearch('');
    setSearch('');
    _setCaseType([]);
    _setPriority([]);
    _setStakeholder([]);
    _setAssignee([]);
    _setProjectSponser([]);
    _setEscalationManager([]);
    _setStatus([]);
    _setExcludeStatus([]);
    _setHasAttachments(false);
    _setIsEscalated(false);
    _setIsFirstResponseTimeViolated(false);
    _setIsSynced(false);
    _setIsResolveTimeViolated(false);
    if (_project !== undefined) {
      _setProject([]);
    }
    if (_organization !== undefined) {
      _setOrganization([]);
    }
    _setDate({
      to: null,
      from: null,
    });
    setState([
      {
        startDate: null,
        endDate: null,
        key: 'selection',
        color: '#c22027',
      },
    ]);
    _setFiltersApplied({
      search: null,
      caseType: null,
      status: null,
      excludeStatus: null,
      priority: null,
      project: null,
      organization: null,
      escalationManager: null,
      stakeholder: null,
      projectSponser: null,
      assignee: null,
      date: null,
      thirdPartySync: null,
      escalatedCases: null,
      hasAttachments: null,
      isFirstResponseTimeViolated: null,
      isResolveTimeViolated: null,
      module: null,
      isApproved: null,
    });
    _setModule([]);
    _setIsApproved(null);
  };

  function areAllKeysNull(obj) {
    const keys = Object.keys(obj);
    const nullValuesCount = keys?.filter((key) => {
      const value = obj[key];
      if (Array.isArray(value)) {
        return value?.every((item) => item?.startDate === null);
      }
      return (
        value === null ||
        value === false ||
        value === '' ||
        (Array.isArray(value) && value?.length === 0)
      );
    })?.length;
    return keys?.length === nullValuesCount;
  }
  const internalFilterStates = {
    _caseType,
    _status,
    search,
    _excludeStatus,
    _priority,
    _project,
    _organization,
    _escalationManager,
    _stakeholder,
    _projectSponser,
    _assignee,
    // _isSynced,
    _isEscalated,
    _hasAttachments,
    _isFirstResponseTimeViolated,
    _isResolveTimeViolated,
    state,
    _date,
    _module,
    _isApproved,
  };

  const handleSubmit = () => {
    setIsSubmit(true);
    const modifiedFiltered = {
      caseType: _caseType,
      status: _excludeStatus?.length ? null : _status,
      search,
      excludeStatus: _status?.length ? null : _excludeStatus,
      priority: _priority,
      project: _project,
      organization: _organization,
      escalationManager: _escalationManager,
      stakeholder: _stakeholder,
      projectSponser: _projectSponser,
      assignee: _assignee,
      date: state,
      hasAttachments: _hasAttachments,
      ...(_isSynced && { thirdPartySync: _isSynced }),
      ...(_isEscalated && { escalatedCases: _isEscalated }),
      ...(_isFirstResponseTimeViolated && {
        isFirstResponseTimeViolated: _isFirstResponseTimeViolated,
      }),
      ...(_isResolveTimeViolated && {
        isResolveTimeViolated: _isResolveTimeViolated,
      }),
      ...(_module && { module: _module }),
      ...(_isApproved && { isApproved: _isApproved }),
    };

    const updatedFiltersApplied = { ..._filtersApplied };

    Object.keys(modifiedFiltered)?.forEach((key) => {
      const value = modifiedFiltered[key];
      
      const result = key.replace(/([A-Z])/g, ' $1');
      const finalResult = result.charAt(0)?.toUpperCase() + result.slice(1);

      if (Array.isArray(value) && key !== 'date') {
        // If the value is an array, update the state accordingly
        const names = value.map((item) => item?.name).filter(Boolean);

        if (value.length > 0) {
          updatedFiltersApplied[key] = {
            name: finalResult,
            data: value,
          };
        }
      } else if (typeof value === 'boolean' && value) {
        // If the value is a boolean and is true, add the name property
        updatedFiltersApplied[key] = {
          name: finalResult,
          data: [`${value}`],
        };
      } else if (key === 'search') {
        updatedFiltersApplied[key] = {
          name: key,
          data: value,
        };
      } else if (key === 'module') {
        updatedFiltersApplied[key] = {
          name: 'Module',
          data: [value],
        };
      } else if (key === 'isApproved') {
        if (_isApproved === 'null') {
          updatedFiltersApplied[key] = {
            name: 'isApproved',
            data: [],
          };
        } else {
          updatedFiltersApplied[key] = {
            name: 'isApproved',
            data: [value],
          };
        }
      } else if (key === 'date' && value[0].startDate && value[0].endDate) {
        // If the key is 'date', update the state in the same format as 'name'
        updatedFiltersApplied[key] = {
          name: key,
          data: [
            `${moment(value[0].startDate).format('YYYY-MM-DD')} - ${moment(
              value[0].endDate
            ).format('YYYY-MM-DD')}`,
          ],
        };
      } else {
        // If the value is not an array, a true boolean, or 'date', update the state accordingly
        updatedFiltersApplied[key] = value;
      }
    });

    _setFiltersApplied(updatedFiltersApplied);
  };

  React.useEffect(() => {
    setSearch(_search);
  }, [_search]);

  React.useEffect(() => {
    setState([
      {
        startDate: _date?.from ? new Date(_date?.from) : null,
        endDate: _date?.to ? new Date(_date?.to) : null,
        key: 'selection',
        color: '#c22027',
      },
    ]);
  }, [_date]);

  return (
    <Drawer
      title="Advanced Filters"
      open={_isOpen}
      onClose={handleClose}
      anchor="right"
      classes={{ paper: classes.createFormSideBar }}
      sx={{
        zIndex: 1300,
      }}>
      <Box className="ticketBody">
        <Typography variant="h4" component="h4">
          Advance Search
        </Typography>
        <Grid container spacing={1}>
          <Grid item container spacing={1.5} md={12} xs={12}>
            <Grid item md={6}>
              <TextField
                id="search-18323038"
                value={search}
                onChange={handleSearch}
                variant="outlined"
                name="search"
                fullWidth
                placeholder="Case no, summary, description..."
                size="small"
                sx={{
                  '& .MuiAutocomplete-input': {
                    minHeight: '38px !important',
                  },
                }}
              />
            </Grid>
            <Grid item md={6}>
              <Autocomplete
                id="issue-name"
                options={allCaseTypes || []}
                multiple
                limitTags={1}
                // ListboxProps={{ style: { maxHeight: '40px' } }}
                size="small"
                value={_caseType || []}
                onChange={(event: any, value: any) => {
                  _setCaseType(value || []);
                  if (!isSubmit) return;
                  if (value?.length === 0) {
                    _setFiltersApplied({
                      ..._filtersApplied,
                      caseType: null,
                    });
                  } else {
                    _setFiltersApplied({
                      ..._filtersApplied,
                      caseType: {
                        name: 'Case Type',
                        data: value?.map((obj) => obj?.name),
                      },
                    });
                  }
                }}
                getOptionLabel={(option) => option?.name}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Tooltip title={option?.name || ''}>
                      <Chip
                        variant="filled"
                        label={
                          index > 0 &&
                          option?.name?.length &&
                          option.name.length > 5
                            ? `${option.name.slice(0, 5)}...`
                            : option?.name || ''
                        }
                        size="small"
                        {...getTagProps({ index })}
                      />
                    </Tooltip>
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    InputLabelProps={{
                      sx: {
                        fontSize: '14px',
                      },
                    }}
                    label="Case Type"
                  />
                )}
              />
            </Grid>
            <Grid item md={6}>
              <Autocomplete
                id="status-183320"
                options={allStatuses || []}
                value={_status || []}
                multiple
                limitTags={1}
                size="small"
                disabled={(_excludeStatus || []).length > 0}
                onChange={(event: any, value: any) => {
                  _setStatus(value || []);
                  if (!isSubmit) return;

                  if (value?.length === 0) {
                    _setFiltersApplied({ ..._filtersApplied, status: null });
                  } else {
                    _setFiltersApplied({
                      ..._filtersApplied,
                      status: {
                        name: 'Status',
                        data: value?.map((obj) => obj?.name),
                      },
                      excludeStatus: null,
                    });
                  }
                }}
                getOptionLabel={(option) => option.name}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Tooltip title={option?.name || ''}>
                      <Chip
                        variant="filled"
                        label={
                          index > 0 &&
                          option?.name?.length &&
                          option.name.length > 5
                            ? `${option.name.slice(0, 5)}...`
                            : option?.name || ''
                        }
                        size="small"
                        {...getTagProps({ index })}
                      />
                    </Tooltip>
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    InputLabelProps={{
                      sx: {
                        fontSize: '14px',
                      },
                    }}
                    label="Status"
                  />
                )}
              />
            </Grid>
            <Grid item md={6}>
              <Autocomplete
                id="priority-183320"
                options={allPriorities || []}
                value={_priority || []}
                multiple
                limitTags={1}
                size="small"
                onChange={(event: any, value: any) => {
                  _setPriority(value || []);
                  if (!isSubmit) return;
                  if (value?.length === 0) {
                    _setFiltersApplied({
                      ..._filtersApplied,
                      priority: null,
                    });
                  } else {
                    _setFiltersApplied({
                      ..._filtersApplied,
                      priority: {
                        name: 'Priority',
                        data: value?.map((obj) => obj?.name),
                      },
                    });
                  }
                }}
                getOptionLabel={(option) => option.name}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Tooltip title={option?.name || ''}>
                      <Chip
                        variant="filled"
                        label={
                          index > 0 &&
                          option?.name?.length &&
                          option.name.length > 5
                            ? `${option.name.slice(0, 5)}...`
                            : option?.name || ''
                        }
                        size="small"
                        {...getTagProps({ index })}
                      />
                    </Tooltip>
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    InputLabelProps={{
                      sx: {
                        fontSize: '14px',
                      },
                    }}
                    label="Priority"
                  />
                )}
              />
            </Grid>
            {_project !== undefined && (
              <Grid item md={6}>
                <Autocomplete
                  id="priority-183320"
                  options={allProjects || []}
                  value={_project || []}
                  multiple
                  limitTags={1}
                  size="small"
                  onChange={(event: any, value: any) => {
                    _setProject(value || []);
                    if (!isSubmit) return;
                    if (value?.length === 0) {
                      _setFiltersApplied({
                        ..._filtersApplied,
                        project: null,
                      });
                    } else {
                      _setFiltersApplied({
                        ..._filtersApplied,
                        project: {
                          name: 'Project',
                          data: value?.map((obj) => obj?.name),
                        },
                      });
                    }
                  }}
                  getOptionLabel={(option) => option.name}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Tooltip title={option?.name || ''}>
                        <Chip
                          variant="filled"
                          label={
                            index > 0 &&
                            option?.name?.length &&
                            option.name.length > 5
                              ? `${option.name.slice(0, 5)}...`
                              : option?.name || ''
                          }
                          size="small"
                          {...getTagProps({ index })}
                        />
                      </Tooltip>
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      InputLabelProps={{
                        sx: {
                          fontSize: '14px',
                        },
                      }}
                      label="Project"
                    />
                  )}
                />
              </Grid>
            )}
            {_organization !== undefined && (
              <Grid item md={6}>
                <Autocomplete
                  id="project-183320"
                  options={allOrganizations || []}
                  value={_organization || []}
                  multiple
                  limitTags={1}
                  size="small"
                  onChange={(event: any, value: any) => {
                    _setOrganization(value || []);
                    if (!isSubmit) return;
                    if (value?.length === 0) {
                      _setFiltersApplied({
                        ..._filtersApplied,
                        organization: null,
                      });
                    } else {
                      _setFiltersApplied({
                        ..._filtersApplied,
                        organization: {
                          name: 'Organization',
                          data: value?.map((obj) => obj?.name),
                        },
                      });
                    }
                  }}
                  getOptionLabel={(option) => option.name}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Tooltip title={option?.name || ''}>
                        <Chip
                          variant="filled"
                          label={
                            index > 0 &&
                            option?.name?.length &&
                            option.name.length > 5
                              ? `${option.name.slice(0, 5)}...`
                              : option?.name || ''
                          }
                          size="small"
                          {...getTagProps({ index })}
                        />
                      </Tooltip>
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      InputLabelProps={{
                        sx: {
                          fontSize: '14px',
                        },
                      }}
                      label="Organization"
                    />
                  )}
                />
              </Grid>
            )}
            <Grid item md={6}>
              <Autocomplete
                id="escalation-manager-183320"
                options={allInternalUsers || []}
                value={_escalationManager || []}
                multiple
                limitTags={1}
                size="small"
                onChange={(event: any, value: any) => {
                  _setEscalationManager(value || []);
                  if (!isSubmit) return;
                  if (value?.length === 0) {
                    _setFiltersApplied({
                      ..._filtersApplied,
                      escalationManager: null,
                    });
                  } else {
                    _setFiltersApplied({
                      ..._filtersApplied,
                      escalationManager: {
                        name: 'Escalation Manager',
                        data: value?.map((obj) => obj?.name),
                      },
                    });
                  }
                }}
                getOptionLabel={(option) => option.name}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Tooltip title={option?.name || ''}>
                      <Chip
                        variant="filled"
                        label={
                          index > 0 &&
                          option?.name?.length &&
                          option.name.length > 5
                            ? `${option.name.slice(0, 5)}...`
                            : option?.name || ''
                        }
                        size="small"
                        {...getTagProps({ index })}
                      />
                    </Tooltip>
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    InputLabelProps={{
                      sx: {
                        fontSize: '14px',
                      },
                    }}
                    label="Escalation Manager"
                  />
                )}
              />
            </Grid>
            <Grid item md={6}>
              <Autocomplete
                id="stakeholder-183320"
                options={allInternalUsers || []}
                value={_stakeholder || []}
                multiple
                limitTags={1}
                size="small"
                onChange={(event: any, value: any) => {
                  _setStakeholder(value || []);
                  if (!isSubmit) return;
                  if (value?.length === 0) {
                    _setFiltersApplied({
                      ..._filtersApplied,
                      stakeholder: null,
                    });
                  } else {
                    _setFiltersApplied({
                      ..._filtersApplied,
                      stakeholder: {
                        name: 'Stakeholder',
                        data: value?.map((obj) => obj?.name),
                      },
                    });
                  }
                }}
                getOptionLabel={(option) => option.name}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Tooltip title={option?.name || ''}>
                      <Chip
                        variant="filled"
                        label={
                          index > 0 &&
                          option?.name?.length &&
                          option.name.length > 5
                            ? `${option.name.slice(0, 5)}...`
                            : option?.name || ''
                        }
                        size="small"
                        {...getTagProps({ index })}
                      />
                    </Tooltip>
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    InputLabelProps={{
                      sx: {
                        fontSize: '14px',
                      },
                    }}
                    label="Stakeholder"
                  />
                )}
              />
            </Grid>
            <Grid item md={6}>
              <Autocomplete
                id="project-sponser-183320"
                options={allExternalUsers || []}
                value={_projectSponser || []}
                multiple
                limitTags={1}
                size="small"
                onChange={(event: any, value: any) => {
                  _setProjectSponser(value || []);
                  if (!isSubmit) return;
                  if (value?.length === 0) {
                    _setFiltersApplied({
                      ..._filtersApplied,
                      projectSponser: null,
                    });
                  } else {
                    _setFiltersApplied({
                      ..._filtersApplied,
                      projectSponser: {
                        name: 'Project Sponsor',
                        data: value?.map((obj) => obj?.name),
                      },
                    });
                  }
                }}
                getOptionLabel={(option) => option.name}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Tooltip title={option?.name || ''}>
                      <Chip
                        variant="filled"
                        label={
                          index > 0 &&
                          option?.name?.length &&
                          option.name.length > 5
                            ? `${option.name.slice(0, 5)}...`
                            : option?.name || ''
                        }
                        size="small"
                        {...getTagProps({ index })}
                      />
                    </Tooltip>
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    InputLabelProps={{
                      sx: {
                        fontSize: '14px',
                      },
                    }}
                    label="Project Sponser"
                  />
                )}
              />
            </Grid>
            <Grid item md={6}>
              <Autocomplete
                id="assignee-183320"
                options={allInternalUsers || []}
                value={_assignee || []}
                multiple
                limitTags={1}
                size="small"
                onChange={(event: any, value: any) => {
                  _setAssignee(value || []);
                  if (!isSubmit) return;
                  if (value?.length === 0) {
                    _setFiltersApplied({
                      ..._filtersApplied,
                      assignee: null,
                    });
                  } else {
                    _setFiltersApplied({
                      ..._filtersApplied,
                      assignee: {
                        name: 'Assignee',
                        data: value?.map((obj) => obj?.name),
                      },
                    });
                  }
                }}
                getOptionLabel={(option) => option.name}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Tooltip title={option?.name || ''}>
                      <Chip
                        variant="filled"
                        label={
                          index > 0 &&
                          option?.name?.length &&
                          option.name.length > 5
                            ? `${option.name.slice(0, 5)}...`
                            : option?.name || ''
                        }
                        size="small"
                        {...getTagProps({ index })}
                      />
                    </Tooltip>
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    InputLabelProps={{
                      sx: {
                        fontSize: '14px',
                      },
                    }}
                    label="Assignee"
                  />
                )}
              />
            </Grid>

            <Grid item md={6}>
              <Autocomplete
                id="status-183320"
                options={allStatuses || []}
                value={_excludeStatus || []}
                multiple
                limitTags={1}
                size="small"
                disabled={(_status || []).length > 0}
                onChange={(event: any, value: any) => {
                  _setExcludeStatus(value || []);
                  if (!isSubmit) return;

                  if (value?.length === 0) {
                    _setFiltersApplied({
                      ..._filtersApplied,
                      excludeStatus: null,
                    });
                  } else {
                    _setFiltersApplied({
                      ..._filtersApplied,
                      status: null,
                      excludeStatus: {
                        name: 'Exclude Status',
                        data: value?.map((obj) => obj?.name),
                      },
                    });
                  }
                }}
                getOptionLabel={(option) => option.name}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Tooltip title={option?.name || ''}>
                      <Chip
                        variant="filled"
                        label={
                          index > 0 &&
                          option?.name?.length &&
                          option.name.length > 5
                            ? `${option.name.slice(0, 5)}...`
                            : option?.name || ''
                        }
                        size="small"
                        {...getTagProps({ index })}
                      />
                    </Tooltip>
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    InputLabelProps={{
                      sx: {
                        fontSize: '14px',
                      },
                    }}
                    label="Exclude Status"
                  />
                )}
              />
            </Grid>
            <Grid item md={6}>
              <Autocomplete
                id="module-filter"
                options={allModules || []}
                value={_module || null}
                size="small"
                onChange={(event: any, value: string | null) => {
                  _setModule(value);
                  if (!isSubmit) return;
                  if (!value) {
                    _setFiltersApplied({
                      ..._filtersApplied,
                      module: null,
                    });
                  } else {
                    _setFiltersApplied({
                      ..._filtersApplied,
                      module: {
                        name: 'Module',
                        data: [value],
                      },
                    });
                  }
                }}
                getOptionLabel={(option) => option || ''}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    InputLabelProps={{
                      sx: {
                        fontSize: '14px',
                      },
                    }}
                    label="Module"
                  />
                )}
              />
            </Grid>
            <Grid item md={6} className="select_item">
              <FormControl fullWidth>
                <InputLabel id="select-isApproved-label">Approval</InputLabel>
                <Select
                  labelId="select-isApproved-label"
                  id="select-approved"
                  value={_isApproved || 'null'}
                  onChange={(event) => {
                    const selected = approvedList.find(
                      (option) => option.value === event.target.value
                    );
                    _setIsApproved(selected.value);

                    if (!isSubmit) return;

                    if (!selected) {
                      _setFiltersApplied({
                        ..._filtersApplied,
                        _isApproved: null,
                      });
                    } else {
                      _setFiltersApplied({
                        ..._filtersApplied,
                        isApproved: {
                          name: 'isApproved',
                          data: selected.value,
                        },
                      });
                    }
                  }}
                  label="Approved">
                  {approvedList.map((option) => (
                    <MenuItem
                      key={String(option.value)}
                      value={String(option.value)}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item md={6} className="calenderFilter">
              <TextField
                value={
                  state[0].startDate
                    ? moment(state[0].startDate).format('MM-DD-YYYY')
                    : 'mm/dd/yyyy'
                }
                onClick={() => {
                  setIsOpen(!isOpen);
                }}
                size="small"
                label="From"
                fullWidth
                InputProps={{
                  style: { minHeight: '40px' },
                  endAdornment: (
                    <InputAdornment position="end">
                      <CalendarTodayIcon color="primary" fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
              {isOpen && (
                <Box ref={ref} className={classes.datePicker}>
                  <DateRange
                    ranges={state}
                    onChange={(item) => {
                      setState([item.selection]);
                      _setDate({
                        from: moment(item?.selection?.startDate).format(
                          'YYYY-MM-DD'
                        ),
                        to: moment(item?.selection?.endDate).format(
                          'YYYY-MM-DD'
                        ),
                      });
                      if (!isSubmit) return;
                      _setFiltersApplied({
                        ..._filtersApplied,
                        date: {
                          name: 'Date',
                          data: [
                            `${moment(item.selection?.startDate).format(
                              'YYYY-MM-DD'
                            )} - ${moment(item.selection?.endDate).format(
                              'YYYY-MM-DD'
                            )}`,
                          ],
                        },
                      });
                    }}
                    editableDateInputs
                  />
                </Box>
              )}
            </Grid>
            <Grid item md={6}>
              <TextField
                value={
                  state[0].endDate
                    ? moment(state[0].endDate).format('MM-DD-YYYY')
                    : 'mm/dd/yyyy'
                }
                disabled
                size="small"
                label="To"
                fullWidth
                InputProps={{
                  style: { minHeight: '40px' },
                  endAdornment: (
                    <InputAdornment position="end">
                      <CalendarTodayIcon color="primary" fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
          <Grid item md={12} xs={12}>
            <Box>
              <Box>
                <Typography fontWeight={500} className="fields">
                  Others
                </Typography>
                <Grid
                  container
                  columns={3}
                  spacing={3}
                  justifyContent="flex-start">
                  {/* <Grid item>
                      <div>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={_isSynced}
                              onChange={toggleIsSynced}
                            />
                          }
                          label="3rd party sync"
                        />
                      </div>
                    </Grid> */}
                  <Grid item>
                    <div>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={_isEscalated}
                            onChange={toggleIsEscalated}
                          />
                        }
                        label="Escalated cases"
                      />
                    </div>
                  </Grid>
                  <Grid item>
                    <div>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={_hasAttachments}
                            onChange={toggleHasAttachments}
                          />
                        }
                        label="Has attachments"
                      />
                    </div>
                  </Grid>
                </Grid>
              </Box>
              <Box>
                <Typography fontWeight={500} className="fields" marginTop={1}>
                  SLA
                </Typography>
                <Box display="flex" className="fields">
                  <div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={_isFirstResponseTimeViolated}
                          onChange={toggleIsFirstResponseTimeViolated}
                        />
                      }
                      label="Is 1st response time violated"
                    />
                  </div>
                  <div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={_isResolveTimeViolated}
                          onChange={toggleIsResolveTimeViolated}
                        />
                      }
                      label="Is resolve time violated"
                    />
                  </div>
                </Box>
              </Box>
            </Box>
            <div className="btns">
              <Button
                variant="contained"
                color="secondary"
                type="submit"
                sx={{ height: '38px' }}
                disabled={areAllKeysNull(internalFilterStates)}
                onClick={handleSubmit}>
                Search
              </Button>
              <Button
                variant="outlined"
                color="primary"
                sx={{ height: '38px', marginLeft: '12px' }}
                disabled={areAllKeysNull(internalFilterStates)}
                onClick={handleReset}>
                Reset
              </Button>
              <Button
                variant="outlined"
                color="primary"
                sx={{ height: '38px', marginLeft: 'auto' }}
                onClick={handleClose}>
                Close
              </Button>
            </div>
          </Grid>
        </Grid>
      </Box>
    </Drawer>
  );
}
